// src/helpers/rutaCajas.js
import api from "./api"; // usar SIEMPRE la instancia unificada

// Cambiá SOLO esto si el recurso se llama distinto en el back:
const RESOURCE = "cajas";                 // ej.: "fondos"
const BASE_PATH = `api/${RESOURCE}`;      // queda /api/cajas

const p = (s = "") => `/${String(s).replace(/^\/+/, "")}`;
const join = (...parts) => {
  const out = parts
    .filter(Boolean)
    .map((x, i) => (i === 0 ? String(x).replace(/\/+$/, "") : String(x).replace(/^\/+/, "")))
    .join("/");
  return `/${out.replace(/^\/+/, "")}`;
};

// GET lista (acepta filtros opcionales: { tipo, activo, q } o params libres)
export const getCajas = async (params = {}) => {
  const url = p(BASE_PATH);
  try {
    const safeParams = { ...params };
    // Normalizo algunos filtros comunes si vienen en minúsculas o booleanos
    if (safeParams.tipo)  safeParams.tipo  = String(safeParams.tipo).toUpperCase(); // CAJA|BANCO
    if (safeParams.activo !== undefined) safeParams.activo = String(safeParams.activo);

    const fullUrl = api.defaults.baseURL + url;
    console.log("[GET]", fullUrl, safeParams);
    const { data } = await api.get(url, { params: safeParams });
    return data; // { ok, cajas, cantidad } (según tu back)
  } catch (err) {
    console.error("[getCajas] ERROR:", err?.response?.status, err?.response?.data || err.message);
    throw err;
  }
};

// Alias semántico útil
export const getFondos = async (tipo) =>
  getCajas(tipo ? { tipo } : {});

// GET por id
export const getCajaById = async (id) => {
  const url = p(join(BASE_PATH, encodeURIComponent(String(id))));
  try {
    const { data } = await api.get(url);
    return data; // { ok, caja }
  } catch (err) {
    console.error("[getCajaById] ERROR:", err?.response?.status, err?.response?.data || err.message);
    throw err;
  }
};

// POST crear
export const postCaja = async (payload) => {
  const url = p(BASE_PATH);
  try {
    const { data } = await api.post(url, payload);
    return data; // { ok, caja }
  } catch (err) {
    console.error("[postCaja] ERROR:", err?.response?.status, err?.response?.data || err.message);
    throw err;
  }
};

// PUT actualizar
export const putCaja = async (id, payload) => {
  const url = p(join(BASE_PATH, encodeURIComponent(String(id))));
  try {
    const { data } = await api.put(url, payload);
    return data; // { ok, caja }
  } catch (err) {
    console.error("[putCaja] ERROR:", err?.response?.status, err?.response?.data || err.message);
    throw err;
  }
};

// DELETE (baja lógica)
export const deleteCaja = async (id) => {
  const url = p(join(BASE_PATH, encodeURIComponent(String(id))));
  try {
    const { data } = await api.delete(url);
    return data; // { ok, caja }
  } catch (err) {
    console.error("[deleteCaja] ERROR:", err?.response?.status, err?.response?.data || err.message);
    throw err;
  }
};
